import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import { buildPath, getNamedParams } from "core/model/lib/urlTools";
import {
  StartRoundModal,
  EditRoundModal,
  PublicDateRoundModal,
} from "../modals";
import { requestData, getData as getListData, getInfo } from "core/ducks/list";
import {
  getData as getUpdateData,
  postData,
  updateData,
} from "core/ducks/update";
import { getValidation, validate } from "core/ducks/forms";
import { ExportToCSV } from "core/model/lib";

import { ErrorPage } from "core/views/pages";
import {
  Filter,
  FilterGroup,
  Table,
  Title,
  Button,
  Tbody,
  Thead,
  Toolbox,
  Tr,
  Search,
  Pagination,
  Checkbox,
} from "table";
import { Loading } from "core/components";

import * as roles from "core/model/roles";
import { StaticRoutes, DynamicRoutes } from "../../model/routes";
import T from "modules/i18n";

class Rounds extends Component {
  constructor(props) {
    super(props);
    this.initialState = {
      query: "",
      status: "",
      sort: "starts",
      sort_method: "desc",
      current_workflow: "",
      httpStatus: 200,
      allChecked: false,
      included: [],
      data: [],
    };

    const { params } = props.match;

    const initialize = {
      status: params && params.status ? params.status : "",
    };
    this.state = {
      ...this.initialState,
      ...initialize,
      page: 1,
      refreshing: false,
      isStartRoundModalOpen: false,
      isEditModalOpen: false,
      isPublicDateModalOpen: false,
      valuesToEdit: {},
      workflows: {},
      underEdit: null,
    };

    this.fields = [
      "workflow_name",
      "label",
      "starts",
      "ends",
      "public_date",
      "active",
    ];

    this.layout = {
      workflow: { sortable: true },
      label: { sortable: true },
      starts: { type: "date", sortable: true },
      ends: { type: "date", sortable: true },
      public_date: { type: "date", sortable: true },
      active: { type: "boolean", sortable: true },
    };

    this.fetchData = this.fetchData.bind(this);
    this.createUrl = this.createUrl.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleWorkflowFilterChange =
      this.handleWorkflowFilterChange.bind(this);
    this.handleCSVExport = this.handleCSVExport.bind(this); // Bind handleCSVExport
		this.handleToolboxReset = this.handleToolboxReset.bind(this);
  }

  componentDidMount() {
    this.fetchData();
    this.fetchWorkflows();
  }

  componentDidUpdate(prevProps, prevState) {
    const { params } = this.props.match;

    if (
      params.status !== prevProps.match.params.status ||
      prevState.query !== this.state.query ||
      prevState.current_workflow !== this.state.current_workflow
    ) {
      let state = { page: 1 };
      if (prevState.query !== this.state.query) {
        state = Object.assign(state, { query: this.state.query });
      }
      if (prevState.current_workflow !== this.state.current_workflow) {
        state = Object.assign(state, {
          current_workflow: this.state.current_workflow,
        });
      }
      this.setState(state, this.fetchData);
    }
  }

  fetchData = () => {
    const url = this.createUrl();
    this.props.dispatch(requestData("round", url)).catch((httpStatus) => {
      this.setState({ httpStatus });
    });
  };

  fetchWorkflows = () => {
    this.props.dispatch(getValidation("round"));
    this.props
      .dispatch(getUpdateData("flows/workflow/type/public/hidden/false"))
      .then((workflows) => {
        this.setState({ workflows });
      });
  };

  createUrl = (base_url = "flows/round") => {
    let { query, sort, sort_method, current_workflow, included } = this.state;
    let url =
      base_url === "flows/round"
        ? `${base_url}/page/${this.state.page}`
        : base_url;
    url = `${url}/sort/${sort}/sort_method/${sort_method}`;
    query = query !== "" ? "/query/" + query : "";
    url += query;
    if (current_workflow) url += "/fq/" + current_workflow;
    if (included && included.length > 0 && !current_workflow)
      url += "/export/" + included.join(",");

    url += "/force/true";

    return url;
  };

  handlePageChange(page) {
    this.setState({ page }, this.fetchData);
  }

  handleWorkflowFilterChange(event) {
    const value = event.target.value;
    this.setState({ current_workflow: value });
  }

  handleQueryChange = ({ target }) => {
    const { value } = target;
    this.setState({ query: value });
  };

  handleSortChange = (sort) => {
    if (sort === this.state.sort) {
      this.setState(
        { sort_method: this.state.sort_method === "asc" ? "desc" : "asc" },
        this.fetchData
      );
    } else {
      this.setState({ sort }, this.fetchData);
    }
  };

  handleNewRoundSubmit = (data) => {
    this.props.dispatch(validate(data, this.props.rules, "round")).then(() => {
      if (this.props.valid)
        this.props.dispatch(postData("flows/round", data)).then(() => {
          this.fetchData();
          this.setState({ isStartRoundModalOpen: false });
        });
    });
  };

  handleEditRoundSubmit = (data) => {
    if (Object.keys(data).length > 0) {
      this.props
        .dispatch(updateData(`flows/round/mname/${this.state.underEdit}`, data))
        .then(() => {
          this.fetchData();
          this.closeEditModal();
        });
    } else {
      this.closeEditModal();
    }
  };

  handleCheckboxChange = (args) => {
    const { index: application_uuid, checked } = args;

    const { included } = this.state;
    const state = {};
    const index = included.indexOf(application_uuid);
    if (checked) {
      if (index === -1) {
        state.included = [...included, application_uuid];
      }
    } else {
      if (index !== -1) {
        state.included = [
          ...included.slice(0, index),
          ...included.slice(index + 1),
        ];
      }
    }
    this.setState({ ...state });
  };

  handleCSVExport() {
    if (this.state.included && this.state.included.length > 0) {
      const { messages } = this.props.i18n || { messages: {} };
      const url = this.createUrl();

      this.props.dispatch(getUpdateData(url)).then((rounds) => {
        const { fieldNames, valuesArray } = this.processResponse(rounds);
    
        let csv = new ExportToCSV("rounds.csv", fieldNames, valuesArray);
        csv.createLink();
      });
    }
  }

  processResponse = (response) => {
    const { messages } = this.props.i18n || { messages: {} };
    // Extract the field names from the first record
    const fieldNames = Object.keys(Object.values(response.values)[0])
      .filter((field) => field !== "workflow")
      .map((field) => (messages[field] ? messages[field] : field));

    // Extract the values for each record, excluding the 'workflow' value
    const valuesArray = Object.values(response.values).map((record) => {
      const { workflow, ...filteredRecord } = record;
      return Object.values(filteredRecord);
    });
    return { fieldNames, valuesArray };
  };

  closeEditModal = () => {
    this.setState({
      isEditModalOpen: false,
      underEdit: null,
      valuesToEdit: {},
    });
  };

  closePublicDateEditModal = () => {
    this.setState({
      isPublicDateModalOpen: false,
      underEdit: null,
      valuesToEdit: {},
    });
  };

  editRound(data) {
    this.setState({
      isEditModalOpen: true,
      valuesToEdit: data,
      underEdit: data.index,
    });
  }

  editRoundPublicDate(data) {
    this.setState({
      isPublicDateModalOpen: true,
      valuesToEdit: data,
      underEdit: data.index,
    });
  }

	handleToolboxReset() {
		this.setState({
			...this.initialState,
			page: 1
		}, this.fetchData);
	}

  render() {
    const { data, info, list } = this.props;
    const {
      isStartRoundModalOpen,
      isEditModalOpen,
      isPublicDateModalOpen,
      workflows,
    } = this.state;

    if (this.state.httpStatus !== 200 && this.state.workflows)
      return <ErrorPage status={this.state.httpStatus} />;
    if (list.round.status !== 200 && list.round.status !== "")
      return <ErrorPage status={list.round.status} />;

    const { messages } = this.props.i18n || { messages: {} };

    return (
      <Row>
        <Col>
          <Table>
            <Title>
              <T>rounds</T>
              <Button type='toolbox' title='filters' className='float-right' />
            </Title>
            <Toolbox onReset={this.handleToolboxReset}>
              <Row>
                <Col xs='12' lg='8' className='form-group text-right'>
                  <Search
                    placeholder={`${messages.title}`}
                    onChange={this.handleQueryChange}
                    name='query'
                  />
                </Col>
                <Col xs='12' lg='4' className='form-group text-right'>
                  <FilterGroup>
                    <Filter
                      onChange={this.handleWorkflowFilterChange}
                      name='current_workflow'
                      defaultValue={workflows}
                    >
                      <option value=''>{`${messages.choose || "choose"} ${
                        messages.workflow || "workflow"
                      }`}</option>
                      {Object.keys(workflows).map((r) => (
                        <option key={`option_${r}`} value={r}>
                          {workflows[r].name}
                        </option>
                      ))}
                    </Filter>
                    {[roles.ADMIN, roles.EDITOR, roles.REVIEWER].includes(
                      this.props.user.role
                    ) && (
                      <Button
                        type='csv'
                        title={`${messages.export || "export"} csv`}
                        onClick={this.handleCSVExport}
                      >
                        <T>export</T> csv
                      </Button>
                    )}
                    <Button
                      color="info" 
                      className="m-1"
                      type='resetFilters'
                      onClick={() =>
                        this.setState({ isStartRoundModalOpen: true })
                      }
                    >
                      <T lettercase='capitalize'>init round</T>
                    </Button>
                    <Button 
                      type="resetFilters" 
                      className="m-1" 
                      title={messages['reset filters'] || 'reset filters'}>
                      <T>reset</T>
                    </Button>
                  </FilterGroup>
                </Col>
              </Row>
            </Toolbox>
            <Thead>
              <Tr
                className='text'
                data={["", ...this.fields]}
                layout={{ ...this.layout }}
                sortBy={this.state.sort}
                sortMethod={this.state.sort_method}
                onClick={this.handleSortChange}
              />
            </Thead>
            {this.props.pending || !data ? (
              <Loading />
            ) : (
              <Tbody refreshing={this.state.refreshing}>
                <Tr
                  data={data ? data : {}}
                  layout={{ ...this.layout }}
                  order={[...this.fields]}
                >
                  {(this.props.user.role === roles.ADMIN ||
                    this.props.user.role === roles.EDITOR) && (
                    <Checkbox
                      allChecked={this.state.allChecked}
                      list={this.state.included}
                      onChange={this.handleCheckboxChange}
                      className='mr-2'
                    />
                  )}
                  <Button
                    type='hourglass-half'
                    title={messages.edit || "edit"}
                    onClick={(data) => {
                      this.editRoundPublicDate(data);
                    }}
                  />
                  <Button
                    condition='not_passed'
                    type='edit'
                    title={messages.edit || "edit"}
                    onClick={(data) => {
                      this.editRound(data);
                    }}
                  />
                </Tr>
              </Tbody>
            )}
            <Pagination
              className='mx-auto'
              page={info.page}
              total={info.total_pages}
              onClick={(page) => {
                if (page !== info.page) this.handlePageChange(page);
              }}
            />
          </Table>
        </Col>
        {isStartRoundModalOpen && (
          <StartRoundModal
            isOpen={isStartRoundModalOpen}
            toggle={() =>
              this.setState({ isStartRoundModalOpen: !isStartRoundModalOpen })
            }
            workflows={workflows}
            onNewRoundSubmit={this.handleNewRoundSubmit}
            validationMessages={this.props.validation_msgs}
          />
        )}
        {isEditModalOpen && (
          <EditRoundModal
            isOpen={isEditModalOpen}
            toggle={this.closeEditModal}
            data={this.state.valuesToEdit}
            onEditRoundSubmit={this.handleEditRoundSubmit}
          />
        )}
        {isPublicDateModalOpen && (
          <PublicDateRoundModal
            isOpen={isPublicDateModalOpen}
            toggle={this.closePublicDateEditModal}
            data={this.state.valuesToEdit}
            onEditRoundSubmit={this.handleEditRoundSubmit}
          />
        )}
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile.user,
  i18n: state.i18n,
  list: state.list,
  pending: state.list.round.pending,
  data: getListData(state, "round"),
  info: getInfo(state, "round"),
  viewData: state.update.response,
  http_status: state.update.status,
  rules: state.forms.validation.rules,
  validation_msgs: state.forms.validation_msgs,
  valid: state.forms.valid,
  user: state.profile.user,
});

Rounds = connect(mapStateToProps)(Rounds);

export default Rounds;
